var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionDisable = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 23,
  viewBox: "0 0 13 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.03798 0.220817C7.24061 0.0162381 5.42584 0.0162382 3.62847 0.220817L1.76726 0.432662C1.49195 0.463998 1.27667 0.684684 1.25218 0.960688L1.10911 2.57276C0.868577 5.28319 0.868577 8.0096 1.10911 10.72L1.25218 12.3321C1.27889 12.6331 1.53104 12.8639 1.83323 12.8639H4.24989V21.5001C4.24989 21.7479 4.40647 21.9686 4.64036 22.0506C4.87424 22.1325 5.13436 22.0577 5.28902 21.8641L5.74483 21.2934C8.46247 17.8908 10.6265 14.081 12.1572 10.0042L12.3793 9.41242C12.4466 9.23326 12.4217 9.03251 12.3127 8.87521C12.2038 8.7179 12.0246 8.62404 11.8332 8.62404H8.66796L11.381 1.21278C11.4425 1.04481 11.4235 0.857913 11.3295 0.705727C11.2355 0.553541 11.0769 0.452891 10.8992 0.432662L9.03798 0.220817Z",
  fill: "#bdbdbd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionDisable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action_disable.e74d247edfc8811ff035641e6ac3c34d.svg";